export const rewriteProjektSchema = (project) => ({
  entityBundle: "projekt",
  label: project.title,
  id: project.id,
  title: project.title,
  fieldSubheader: project.subheader,
  fieldStartOfConstruction: {
    value: project.start_of_construction?.length ? new Date(+project.start_of_construction * 1000).toISOString() : undefined
  },
  fieldPlanning: {
    value: project.planning?.length ? new Date(+project.planning * 1000).toISOString() : undefined,
    endValue: project.planning_end?.length ? new Date(+project.planning_end * 1000).toISOString() : undefined
  },
  fieldCompletion: {
    value: project.completion?.length ? new Date(+project.completion * 1000).toISOString() : undefined
  },
  fieldCompetition: {
    value: project.competition?.length ? new Date(+project.competition * 1000).toISOString() : undefined
  },
  fieldMarketLaunch: {
    value: project.market_launch?.length ? new Date(+project.market_launch * 1000).toISOString() : undefined
  },
  fieldDiscipline: [
    {
      name: project.discipline
    }
  ],
  fieldCity: project.city,
  fieldRegion: {
    name: project.region?.length && project.region,
  },
  created: project.created,
  path: {
    alias: project.url,
  },
  url: {
    path: project.url,
  },
  fieldHervorgehoben: false,
  fieldSchlagwort: [],
  fieldClientShort: project.client_short,
  fieldImages: project.image_url?.length && project.image_url_loading?.length ? ([
    {
      fieldMediaImage: {
        alt: project.title,
        title: project.title,
        style: {
          url: project.image_url,
          width: +project.image_width,
          height: +project.image_height,
        },
        loading: {
          url: project.image_url_loading,
        }
      }
    }
  ]) : []
});
